import React from 'react'

import { bool } from 'prop-types'

function Header({ isSignup }) {
  return (
    <div className="ai-sign-in-modal__header-group">
      <p className="ai-sign-in-modal__title cgt-heading-300">
        {isSignup ? 'Create an account to get started' : 'Welcome back'}
      </p>
      <p className="ai-sign-in-modal__subtitle cgt-body-md">
        {isSignup
          ? 'We will email you a 6-digit code, so you can sign in without having to create the password.'
          : 'Log in to keep creating, designing and downloading.'}
      </p>
    </div>
  )
}

Header.propTypes = {
  isSignup: bool.isRequired,
}

export default Header
